export const trimStringToFullWords = (input, maxLength) => {
  if (!input) return ''
  if (input.length <= maxLength) return input

  input = input.slice(0, maxLength + 1)

  const indexOfLastSpace = input.lastIndexOf(' ')

  if (indexOfLastSpace !== -1) input = input.slice(0, indexOfLastSpace)

  return indexOfLastSpace !== -1 ? input.slice(0, indexOfLastSpace) : ''
}
